module.exports = __webpack_public_path__ + "2cb438a7e33fe25ad1a749da6e424f51.svg";